module.exports = __webpack_public_path__ + "static/media/PoweredByDQ_white.0b998167.png";